import ShopCard from "../components/ui/ShopCard/ShopCard";
import Card from "../components/ui/Card/Card";
import ArticleCard from "../components/ui/ArticleCard/ArticleCard";
import SupportCard from "../components/ui/SupportCard/SupportCard";
import {SlArrowDown, SlArrowRight, SlArrowUp} from "react-icons/sl";
import Locales from "../assets/const/locales";


const mapping = {

    getProductSorting: (labels) => {
        return [
            {label: labels['mostRelevant'], value: 1},
            {label: labels['priceDesc'], value: 2},
            {label: labels['priceAsc'], value: 3},
            {label: labels['alphabeticalDesc'], value: 4},
            {label: labels['alphabeticalAsc'], value: 5},
        ];
    },

    getProductsPerPage: (labels) => {
        return [
            {label: labels['perPage12'], value: 12},
            {label: labels['perPage24'], value: 24},
            {label: labels['perPage48'], value: 48},
        ];
    },

    getTabs: (labels, devicesItems, rateplansItems, articlesItems, supportItems) => {
        return [
            {id: 'products', label: labels?.productsTitle, count: devicesItems?.count || 0},
            {id: 'rateplans', label: labels?.rateplansTitle, count: rateplansItems?.count || 0},
            {id: 'articles', label: labels?.articlesTitle, count: articlesItems?.count || 0},
            {id: 'support', label: labels?.supportTitle, count: supportItems?.count || 0}
        ];
    },
    getItemsMap: (devices, rateplans, articles, support) => {
        return {
            products: devices ? devices?.items || [] : '',
            rateplans: rateplans ? rateplans?.items || [] : '',
            articles: articles ? articles?.items || [] : '',
            support: support ? support?.items || [] : ''
        };
    },
    characteristicsMap: {
        toFixed: 'minutesToFixed',
        toMobile: 'minutesToMobile',
        SMS: 'smsCharacteristics',
        Data: 'dataCharacteristics',
        toNational: 'minutesToNational',
        TV: 'tvCharacteristics',
        Mbps: 'downloadSpeed',
        uploadSpeed: 'uploadSpeed'
    },
    tabContent: {
        products: {
            className: 'products-grid',
            Component: ShopCard,
            getTabContent: (item, onLearnMore, labels, isFromListing) => ({
                device: item,
                onLearnMore,
                tabText: item?.discount,
                labels,
                isFromListing
            })
        },
        rateplans: {
            className: 'rateplans-grid',
            Component: Card,
            getTabContent: (item , onLearnMore, labels) => ({
                rateplan: item,
                onLearnMore,
                tabText: item?.discount,
                buttonText: labels['learnMore'],
                priceLabelText: labels['monthlyPay'],
            })
        },
        articles: {
            className: 'articles-grid',
            Component: ArticleCard,
            getTabContent: (item) => ({
                title: item?.title,
                description: item?.description,
                link: item?.url,
            }),
        },
        support: {
            className: 'support-grid',
            Component: SupportCard,
            getTabContent: (item) => ({
                title: item?.title,
                description: item?.description,
                link: item?.url,
            }),
        },
    },
    filterContent: (
        category,
        subItem,
        item,
        subItemsLength,
        selectedOptions,
        handleFilterOptionChange,
        handleRadioFilterOptionChange,
        toggleSubCategoryExpansion,
        expandedSubCategories,
        toggleCategorySelection,
        isCheckboxVisible,
        isFromListing,
        lang
    ) => {
        const categoryLowerCase = category.toLowerCase();
        const filterConfig = {
            'κατηγορία': {
                type: 'none',
                display: () => (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {subItemsLength > 1 && expandedSubCategories && expandedSubCategories[subItem?.title] ? (
                        <SlArrowDown
                            style={{ marginLeft: '5px' }}
                            onClick={(e) => {
                                e.stopPropagation();
                                toggleSubCategoryExpansion(category, subItem?.title)
                            }}
                        />
                        ) : (
                        <SlArrowRight
                            style={{ marginLeft: '5px' }}
                            onClick={(e) => {
                                e.stopPropagation();
                                toggleSubCategoryExpansion(category, subItem?.title)
                            }}
                        />
                        )}
                        <label style={{cursor:'pointer'}}
                               onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            toggleCategorySelection(subItem?.title, item, subItem?.title)
                        }}>
                            &nbsp; {subItem?.title}
                        </label>
                        { selectedOptions[item.categoryId]?.some((entry) => entry?.category === subItem?.title) &&
                            <input
                                type="checkbox"
                                className="custom-checkbox"
                                style={{
                                    marginLeft: '10px',
                                    display: selectedOptions[item?.categoryId]?.some((entry) => entry?.category === subItem?.title) ? 'block' : 'none',
                                }}
                                checked
                                onChange={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    toggleCategorySelection(subItem?.title, item, subItem?.title)
                                }}
                            />
                        }
                    </div>
                )
            },
            'οθόνη αφής': {
                type: 'radio',
                display: () => (
                    <>
                        <input
                            type="radio"
                            className="custom-radio"
                            name={`filter-radio-${subItem?.title}`}
                            value={item?.title}
                            checked={selectedOptions[item.categoryId]?.some(option => option?.category === subItem?.title) || false}
                            onChange={() => handleRadioFilterOptionChange(subItem?.title, item?.categoryId)}
                        />
                        &nbsp; {subItem?.title === "false"
                        ? lang === "en"
                            ? "No"
                            : "Όχι"
                        : subItem?.title === "true"
                            ? lang === "en"
                                ? "Yes"
                                : "Ναι"
                            : subItem?.title}
                    </>
                ),
            },
            default: {
                type: 'checkbox',
                display: () => (
                    <>
                        <input
                            type="checkbox"
                            className="custom-checkbox"
                            checked={selectedOptions[item.categoryId]?.some(option => option.category === subItem.title) || false}
                            onChange={() => handleFilterOptionChange(subItem?.title, item?.categoryId, null, isFromListing)}
                        />
                        &nbsp; {subItem?.title === "false"
                        ? lang === "en"
                            ? "No"
                            : "Όχι"
                        : subItem?.title === "true"
                            ? lang === "en"
                                ? "Yes"
                                : "Ναι"
                            : subItem?.title}
                    </>
                ),
            },
        };
        let config = filterConfig.default;
        if (categoryLowerCase==='κατηγορία' && isFromListing) {
            config = filterConfig.default
        } else {
            config = filterConfig[categoryLowerCase] || filterConfig.default;
        }
        return config.display();
    }

};

export default mapping;
